import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { tokens } from "../tokens";

/**
 * The warning is shown in full — the current screen clamps it to two lines
 * with an ellipsis, which truncates the sentence it is trying to make.
 */
const CautionNote = () => (
  <Box
    sx={{
      display: "flex",
      // Never stretched by the row; it only ever sets the row height.
      alignSelf: "flex-start",
      gap: 1.5,
      backgroundColor: tokens.dangerSoft,
      border: `1px solid ${tokens.dangerBorder}`,
      borderRadius: tokens.cardRadius,
      padding: "16px 18px",
      color: tokens.danger,
    }}
  >
    <ErrorOutlineIcon sx={{ fontSize: 20, mt: "1px", flexShrink: 0 }} />
    <Box>
      <Typography sx={{ fontSize: 13, fontWeight: 700, mb: 0.5 }}>
        Update with Caution:
      </Typography>
      <Typography sx={{ fontSize: 12.5, lineHeight: 1.5, opacity: 0.92 }}>
        Please proceed with extreme care when making updates, as these changes
        may adversely affect the overall design functionality. Ensure thorough
        testing and validation to avoid any unintended disruptions or errors in
        the end user experience.
      </Typography>
    </Box>
  </Box>
);

export default CautionNote;
